'use strict';

import * as Headroom from 'headroom.js';

const SELECTOR = '.global-header';

var options = {
    offset : 80,
    tolerance : 0,
    classes : {
        initial : "global-header--init",
        pinned : "global-header--pinned",
        unpinned : "global-header--unpinned",
        top : "global-header--top",
        notTop : "global-header--not-top",
        bottom : "global-header--bottom",
        notBottom : "global-header--not-bottom",
        frozen: "global-header--frozen"
    },
};

(function () {
    const element = document.querySelector(SELECTOR);

    if (element === null) {
        return false;
    }

    const headroom = new Headroom(element, options);

    headroom.init();
}());
